import { FormControl, MenuItem, Select } from "@material-ui/core";
import { React } from "react";
import { useTranslation } from "react-i18next";

const ChildrenQtySelect = props => {
    const { t } = useTranslation();
    const selectItems = [
        t('numbers.none'),
        t('numbers.one'),
        t('numbers.two'),
        t('numbers.three'),
        t('numbers.four'),
        t('numbers.five'),
        t('numbers.six'),
        t('numbers.seven'),
        t('numbers.eight'),
        t('numbers.nine'),
        t('numbers.ten')
    ];

    return (
        <FormControl variant="outlined" style={{ width: '100%' }}>
            <Select
                id="childrenQty"
                value={props.value}
                onChange={props.onQtyChange}
                style={{ fontSize: 20 }}
            >
                {selectItems.map((item, i) => {
                    return <MenuItem value={i} key={i} style={{ fontSize: 20 }}>{item}</MenuItem>
                })}
            </Select>
        </FormControl>
    )
}

export default ChildrenQtySelect;